import { FC } from "react";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import { isRequired } from "../../../shared";
import styles from "./selectFieldWithError.module.scss";

interface SelectFieldProps {
  name: string;
  label: string;
  placeholder: string;
  options: Array<{ id: string; title: string; label?: string }>;
  onChange?: (value: string) => void;
  disabled?: boolean;
  defaultValue?: string;
  submitFailed?: boolean;
  hideRequiredStar?: boolean;
  hasBrowserRequiredBehavior?: boolean;
  customClassName?: string;
}

export const SelectFieldWithError: FC<SelectFieldProps> = ({
  name,
  label,
  placeholder,
  options,
  onChange,
  disabled = false,
  defaultValue,
  submitFailed,
  hideRequiredStar = false,
  hasBrowserRequiredBehavior = false,
  customClassName,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`${styles.select_wrap}  ${customClassName || ""} select_wrap`}
    >
      <label htmlFor={name}>
        {label}
        {!hideRequiredStar && "*"}
      </label>
      <Field
        name={name}
        id={name}
        component="select"
        validate={isRequired}
        disabled={disabled}
        defaultValue={defaultValue}
        onChange={
          onChange
            ? (e: React.ChangeEvent<HTMLSelectElement>) =>
                onChange(e.target.value)
            : undefined
        }
        required={hasBrowserRequiredBehavior}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((option) => (
          <option value={option.id} key={option.id}>
            {option.label || option.title}
          </option>
        ))}
      </Field>
      <Field
        name={name}
        subscription={{ error: true }}
        render={({ meta }) =>
          submitFailed &&
          meta.error && <span className="error">{t(meta.error)}</span>
        }
      />
    </div>
  );
};
